import { render, staticRenderFns } from "./tpl.vue?vue&type=template&id=35af5d40&scoped=true"
import script from "./tpl.vue?vue&type=script&lang=js"
export * from "./tpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af5d40",
  null
  
)

export default component.exports